module.exports = __webpack_public_path__ + "img/appIconSample.40064082.svg";